import React from "react";
import {education} from "../utils/constants";

function EducationPage() {
    return (
        <div className="container" id="Education">
            <div className="hero-block">
                <div className="hero-heading-wrap">
                    <div className="hero-icon">
                        <div className="icon-svg w-embed">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                 className="w-6 h-6">
                                <path
                                    d="M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z"/>
                            </svg>
                        </div>
                    </div>
                    <h1 className="hero-heading">Education</h1>
                </div>
                <div className="text-lead">
                    My education journey and growth
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Qualifications</h2>
                </div>
                <div className="w-dyn-list">
                    <div role="list" className="_2x-column w-dyn-items">
                        {education.map((item) => (
                            <div role="listitem" className="cms-item w-dyn-item">
                                <div className="card w-inline-block">
                                    <div className="shine-wrap">
                                        <div className="shine"></div>
                                    </div>
                                    <div className="card-content-vertical">
                                        <div className="card-meta">
                                            <div className="card-info">
                                                <div>{item.startDate}</div>
                                                <div>•</div>
                                                <div>{item.endDate}</div>
                                            </div>
                                            <div className="card-cta-wrap">
                                                <div className="card-badge">Completed</div>
                                                <div className="card-cta">
                                                    <div className="icon-svg w-embed">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">
                                                {item.courseName}
                                            </h2>
                                            <div className="card-text-2-lines">
                                                {item.institution}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EducationPage